<template>
  <div class="app-filter">
    <WsText001 v-if="title" class="mb-6" h6 bold>
      {{ $t(title) }}
    </WsText001>
    <SearchInput
      v-if="type === 'search'"
      :value="value"
      :placeholder="placeholder"
      @input="$_onChange($event)"
    />
    <DropdownMultipleSelectButton
      v-else-if="type === 'one-layer-dropdown'"
      :value="value"
      :menu-items="items"
      :placeholder="placeholder"
      outline
      :select-all="selectAll"
      :has-search="hasSearch"
      @input="$_onChange($event)"
    />
    <StateDropdownSelectClassification
      v-else-if="type === 'two-layer-dropdown'"
      :value="value"
      outline
      :btn-icon="btnIcon"
      :menu="items"
      :placeholder="placeholder"
      :all-select-text="allSelectText"
      @input="$_onChange($event)"
    />
    <DropdownMenuButton
      v-else-if="type === 'radio-dropdown'"
      :value="value"
      outline
      :dropdown-menu-item="items"
      :placeholder="placeholder"
      :has-search="hasSearch"
      :disableCancel="disableCancel"
      @input="$_onChange($event)"
    />
    <DurationDatePicker
      v-else-if="type === 'date-duration'"
      class="mt-0"
      :placeholder="placeholder"
      :value="value"
      :default-value="defaultValue"
      :scroll="scroll"
      :leftBtnText="leftBtnText"
      @input="$_onChange($event)"
    />
    <DropdownSelectMenuButton
      v-else-if="type === 'contractor'"
      :value="value"
      outline
      text-item
      :placeholder="$t('選擇')"
      model-name="contractor"
      @input="$_onChange($event)"
    />
    <DropdownCustomedMultipleSelectButton
      v-else-if="type === 'contractor-type'"
      :value="value"
      :menu-items="items"
      :placeholder="placeholder"
      outline
      select-all
      :allSelectText="allSelectText"
      @input="$_onChange($event)"
    />
    <WsButton001
      v-else-if="type === 'button'"
      :primary="primary"
      :no-padding="noPadding"
      :font-size-lg="fontSizeLg"
      :leading-icon="leadingIcon"
      @click="$_btnClick()"
    >
      {{ btnText }}
    </WsButton001>
    <WsButtonWithPopup001
      v-else-if="type === 'download-btns'"
      is-position-up
      width-stretch
      :text-label="btnText"
      :leading-icon="leadingIcon"
      :btn-list="downloadBtnList"
      @btn-click="$_downloadClick($event)"
    />
    <LvDropdownMenuMultiLayer
      v-else-if="type === 'multi-layer-dropdown'"
      :value="value"
      :items="items"
      @click="$_onChange($event)"
    />
    <WsStateDropdownCheckboxInputAvatar001
      v-else-if="type === 'avatars'"
      :value="value"
      outline
      leading-icon="icon-outline-perm-identity"
      :placeholder="placeholder"
      @input="$_onChange($event)"
    />
    <WsStateDropdownCheckboxInputAvatar001
      v-else-if="type === 'fetchCheckbox'"
      outline
      type="custom"
      :value="value"
      :customUrl="url"
      :showAvatar="false"
      :customParams="params"
      :leadingIcon="leadingIcon"
      :placeholder="placeholder"
      :emptyText="emptyText"
      @input="$_onChange($event)"
    />
    <LvStateDropdownRadioInputAvatar001
      v-else-if="type === 'avatar'"
      :value="value"
      :placeholder="placeholder"
      :leading-icon="leadingIcon"
      outline
      required
      avatar-select
      @input="$_onChange($event)"
    />
  </div>
</template>
<script>
export default {
  name: 'AppFilter',
  props: {
    type: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number, Object, Array],
      default: null,
    },
    title: {
      type: String,
    },
    placeholder: {
      type: String,
      default: 'placeholder',
    },
    items: {
      type: Array,
      default() {
        return [];
      },
    },
    btnIcon: {
      type: String,
      default: '',
    },
    allSelectText: {
      type: String,
      default: '',
    },
    leadingIcon: {
      type: String,
      default: '',
    },
    fontSizeLg: {
      type: Boolean,
      default: false,
    },
    noPadding: {
      type: Boolean,
      default: false,
    },
    primary: {
      type: Boolean,
      default: false,
    },
    btnText: {
      type: String,
      default: '',
    },
    downloadBtnList: {
      type: Array,
      default() {
        return [];
      },
    },
    defaultValue: {},
    selectAll: {
      type: Boolean,
      default: true,
    },
    hasSearch: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
    },
    params: {
      type: Object,
    },
    emptyText: {
      type: String,
    },
    scroll: {
      type: Number,
    },
    leftBtnText: {
      type: String,
    },
    disableCancel: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    $_onChange($event) {
      this.$emit('input', $event);
    },
    $_btnClick() {
      this.$emit('button');
    },
    $_downloadClick($event) {
      const event = {
        ...$event,
        type: this.type,
      };
      this.$emit('download-click', event);
    },
  },
};
</script>
